import { z } from 'zod';
// The artifact types a deployment can publish: what `publishArtifact` accepts,
// and what the front has a component and an icon for. Kept here so the two
// cannot drift — they were three separate lists, one of them untyped. Only
// html is not offered to the agent: it is a webpage whose folder holds its own
// index.html, told apart when it is published.
//
// `ArtifactSchema.type` stays a plain string on purpose: a stored artifact whose
// type has since been withdrawn still has to travel and be labelled, so the wire
// must not refuse it.
export const ARTIFACT_TYPES = ['map', 'table', 'chart', 'webpage', 'html'];
export const ArtifactTypeSchema = z.enum(ARTIFACT_TYPES);
// The entry of an html page: what the front frames.
export const ARTIFACT_INDEX_FILE = 'index.html';
export const ArtifactSchema = z.object({
    id: z.string(),
    artifactId: z.string(),
    conversationId: z.string(),
    type: z.string(),
    title: z.string(),
    slug: z.string(),
    version: z.number().int(),
    createdAt: z.iso.datetime(),
    shareToken: z.string().optional()
});
export const ArtifactWithContentSchema = ArtifactSchema.extend({
    content: z.unknown()
});
